import { render, staticRenderFns } from "./AddDigitalBooks.vue?vue&type=template&id=af760ec8&scoped=true&"
import script from "./AddDigitalBooks.vue?vue&type=script&lang=js&"
export * from "./AddDigitalBooks.vue?vue&type=script&lang=js&"
import style0 from "./AddDigitalBooks.vue?vue&type=style&index=0&id=af760ec8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af760ec8",
  null
  
)

export default component.exports